// Core
import React from "react";
import { Table } from "react-bootstrap";

// Styles
import "./style.scss";

// Components
import Pagination from "Components/Pagination";
import SortButton from "Components/SortButton";
import Skeleton from "react-loading-skeleton";  
import "react-loading-skeleton/dist/skeleton.css";

const NormalTable = ({
  headers,
  children,
  customStyle,
  sort,
  setSort,
  noDataLabel,
  bordered = false,
  noDataColspan,
  isStickyTableHeader = false,
  collapsableColumns = [],
  showCollapsedColumns = false,
  currentPage,
  totalPages,
  loading = false, // New prop
  skeletonRowCount = 8,
  handlePageChange = () => {},
}) => {
  const {
    customTableHeaderContainer,
    customTableContainer,
    customHeaderTitle,
    customTable,
    customNoDataTitle,
    customTableHeaderWrapper,
    customHeaderTitleCollapsed,
    customNODataCount,
  } = customStyle;

   // Skeleton loader rows
   const renderSkeletonRows = () => {
    return Array.from({ length: skeletonRowCount }).map((_, index) => (
      <tr key={`skeleton-${index}`}>
        {headers.map((_, i) => (
          <td key={`skeleton-col-${i}`}>
            <Skeleton height={25} width={150} />
          </td>
        ))}
      </tr>
    ));
  };

  return (
    <>
      <div className={customTableContainer}>
        <div className={"table-responsive"}>
          <Table
            bordered={bordered}
            className={`${customTable} ${
              isStickyTableHeader && "stickyTable"
            } borderCollapseTable`}
          >
            <thead className={isStickyTableHeader && "stickyHead"}>
              <tr className={customTableHeaderWrapper}>
                {headers.map(({ label, isSort, key, isInfo , headerStyle}, index) => {
                  return (
                    <>
                      <th
                        key={index}
                        className={`${customTableHeaderContainer} `}
                      >
                        <div
                          className={`${customHeaderTitle} displayAlignMent`}
                        >
                          <div  style={headerStyle || {}}>{label}</div>
                          {isSort === true && (
                            <div
                              style={{
                                background: "transparent",
                                marginLeft: "5px"                                
                              }}
                            >
                              <SortButton
                                sortObj={sort}
                                sortHandler={setSort}
                                name={key}
                              />
                            </div>
                          )}
                        </div>
                      </th>
                    </>
                  );
                })}
                {collapsableColumns.length ? (
                  <div
                    className={`collapsWrapper ${
                      showCollapsedColumns
                        ? "collapsWrapperOpen"
                        : "collapsWrapperClose"
                    }`}
                  >
                    <>
                      {showCollapsedColumns &&
                        collapsableColumns.map(
                          ({ label, isSort, key }, index) => {
                            return (
                              <>
                                <th
                                  key={index}
                                  className={`${customTableHeaderContainer}`}
                                >
                                  <div
                                    className={`${customHeaderTitle} displayAlignMent ${customHeaderTitleCollapsed}`}
                                  >
                                    <div>{label}</div>
                                    {isSort === true && (
                                      <div
                                        style={{ background: "transparent" }}
                                      >
                                        <SortButton
                                          sortObj={sort}
                                          sortHandler={setSort}
                                          name={key}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </th>
                              </>
                            );
                          }
                        )}
                    </>
                  </div>
                ) : null}
              </tr>
            </thead>
            <tbody>
            {loading ? (
                renderSkeletonRows() 
              ) : !noDataLabel ? (
                children
              ) : (
                <tr>
                  <td
                    colSpan={noDataColspan}
                    className={`text-center ${customNODataCount}`}
                  >
                    <label className={customNoDataTitle}>No Data Found</label>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {!noDataLabel?.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
};

export default NormalTable;
